import { Button } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";

interface StarProfessionalButtonProps {
  isStarred: boolean;
  handleStarProfessional: () => void;
  visible: boolean;
}

export function StarProfessionalChatButton(props: StarProfessionalButtonProps) {
  const { isStarred, handleStarProfessional, visible } = props;

  if (!visible) {
    return null;
  }

  return isStarred ? (
    <Button onClick={handleStarProfessional} variant="contained">
      {/* Include icon as child instead of passing to Button's startIcon
      prop to allow for styling overrides. Apply same margins as startIcon */}
      <StarIcon sx={{ fontSize: 18, mr: 1, ml: -0.5 }} />
      Starred
    </Button>
  ) : (
    <Button
      onClick={handleStarProfessional}
      variant="outlined"
      sx={{ border: (theme) => `1px solid ${theme.palette.divider}` }}
    >
      <StarBorderIcon sx={{ fontSize: 18, mr: 1, ml: -0.5 }} />
      Add to Starred
    </Button>
  );
}
